import { Injectable, ViewContainerRef } from '@angular/core';

@Injectable()
export class ShellService {
  private vcr: ViewContainerRef;

  setRootElement(vcr: ViewContainerRef) {
    this.vcr = vcr;
  }

  getRootElement() {
    return this.vcr;
  }

  clearRootElement() {
    this.vcr = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/shell.service.ts